import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import * as endPoints from '../assets/js/endpoints'
import {
  Container,
  Box,
  TextField,
  Button,
  Card,
  CardContent,
  InputAdornment,
  IconButton,
  Typography,
  Autocomplete,
  Avatar,
  Checkbox,
  FormControlLabel
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
//import fondo from '../assets/images/fondos/6.png'
import { useNotification } from '../assets/contexts/notificationContext';
import PageTitle from '../components/PageTitle';
import Loader from '../components/loader';
import { Helmet } from 'react-helmet';
import {
  INTRANET_FORM_CARD_SX,
  INTRANET_FORM_GRID_SX,
  INTRANET_FULL_WIDTH_FIELD_SX,
  INTRANET_PAGE_CONTAINER_SX,
  INTRANET_WIDE_FIELD_SX,
} from '../constants/layout';

export default function EditUsuarios() {
    const [loading, setLoading] = useState(true);
    const { id } = useParams();
    const [name, setName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [rol, setRol] = useState('');
    const [roles, setRoles] = useState([]);
    const [password, setPassword] = useState('');
    const [showPass, setShowPass] = useState(false);
    const [bio, setBio] = useState('');
    const [image, setImage] = useState(null);
    const [category, setCategory] = useState('');
    const [categories, setCategories] = useState([]);
    const [service, setService] = useState('');
    const [services, setServices] = useState([]);
    const [color, setColor] = useState('#000000');
    const [active, setActive] = useState(true);
    const [showInAbout, setShowInAbout] = useState(true);
    const [employeeOrder, setEmployeeOrder] = useState('');
    const [fileName, setFileName] = useState('');
    const [currentImagePath, setCurrentImagePath] = useState('');
    const [removeCurrentImage, setRemoveCurrentImage] = useState(false);
    const navigate = useNavigate();
    const { showNotification } = useNotification();

    const validatePassword = p => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(p);

    const handleImageChange = e => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setFileName(file.name);
            setImage(file);
            setRemoveCurrentImage(false);
        }
    };

    const handleRemoveImage = () => {
        setImage(null);
        setFileName('');
        setCurrentImagePath('');
        setRemoveCurrentImage(true);
    };

    const imagePreviewUrl = image
        ? URL.createObjectURL(image)
        : (!removeCurrentImage && currentImagePath ? endPoints.BACKEND_URL + currentImagePath : '');

    useEffect(() => {
        return () => {
            if (imagePreviewUrl && image) {
                URL.revokeObjectURL(imagePreviewUrl);
            }
        };
    }, [imagePreviewUrl, image]);


    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const [allRoles, allCategories, allServices, currentUser] = await Promise.all([
                    endPoints.getAllRoles(),
                    endPoints.getAllCategories(),
                    endPoints.getAllServices(),
                    endPoints.getUserById(id)
                ]);

                setRoles(allRoles);
                setCategories(allCategories);
                setServices(allServices);

                setName(currentUser.name);
                setLastName(currentUser.last_name || '');
                setEmail(currentUser.email);
                setRol(currentUser.roles?.length > 0 ? currentUser.roles[0].name : '');
                setBio(currentUser.bio || '');
                setCategory(currentUser.category_id || '');
                setService(currentUser.services?.length > 0 ? currentUser.services[0].id : '');
                setColor(currentUser.color || '#000000');
                setActive(currentUser.active !== false);
                setShowInAbout(currentUser.show_in_about !== false);
                setEmployeeOrder(currentUser.employee_order ?? '');
                if (currentUser.image) {
                    const urlParts = currentUser.image.split('/');
                    setFileName(urlParts[urlParts.length - 1]);
                    setCurrentImagePath(currentUser.image);
                }
            } catch (error) {
                showNotification('Error cargando usuario', 'error');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id, showNotification]);



if (loading) return <Loader />;


    return (
        <>
        <Helmet>
            <title>Editar Usuario | CES</title>
        </Helmet>
        <Container maxWidth="xl" sx={INTRANET_PAGE_CONTAINER_SX}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, maxWidth: 800, mx: 'auto' }}>
                <Button variant="contained" startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)}>
                    Volver
                </Button>
            </Box>
            <Card sx={INTRANET_FORM_CARD_SX}>
                <CardContent>

                    <Box component="form" onSubmit={handleGuardar} sx={INTRANET_FORM_GRID_SX}>
                        <Box sx={INTRANET_WIDE_FIELD_SX}>
                            <PageTitle>Editar Usuario</PageTitle>
                            {name && (
                                <Typography variant="subtitle1" color="text.secondary">
                                    {name} {lastName}
                                </Typography>
                            )}
                        </Box>

                        

                        <TextField
                            fullWidth
                            label="Nombre"
                            value={name}
                            onChange={e => setName(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            sx={INTRANET_FULL_WIDTH_FIELD_SX}
                        />
                        <TextField
                            fullWidth
                            label="Apellidos"
                            value={lastName}
                            onChange={e => setLastName(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            sx={INTRANET_FULL_WIDTH_FIELD_SX}
                        />
                        <TextField
                            fullWidth
                            label="Email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            sx={INTRANET_FULL_WIDTH_FIELD_SX}
                        />

                        <TextField
                            fullWidth
                            label="Nueva contraseña"
                            type={showPass ? 'text' : 'password'}
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => setShowPass(p => !p)} edge="end">
                                            {showPass ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                            sx={INTRANET_FULL_WIDTH_FIELD_SX}
                        />
                        <Autocomplete
                            options={categories}
                            value={categories.find(c => String(c.id) === String(category)) || null}
                            onChange={(_event, newValue) => setCategory(newValue ? newValue.id : '')}
                            getOptionLabel={option => option.name || option.title || ''}
                            isOptionEqualToValue={(option, value) => String(option.id) === String(value.id)}
                            renderInput={params => (
                                <TextField {...params} label="Categoría" fullWidth sx={INTRANET_FULL_WIDTH_FIELD_SX} />
                            )}
                        />

                        <TextField
                            type="color"
                            label="Color"
                            value={color}
                            onChange={e => setColor(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            sx={INTRANET_FULL_WIDTH_FIELD_SX}
                            fullWidth
                        />
                        
                        <Autocomplete
                            options={services}
                            value={services.find(s => String(s.id) === String(service)) || null}
                            onChange={(_event, newValue) => setService(newValue ? newValue.id : '')}
                            getOptionLabel={option => option.name || option.title || ''}
                            isOptionEqualToValue={(option, value) => String(option.id) === String(value.id)}
                            renderInput={params => (
                                <TextField {...params} label="Servicio" fullWidth sx={INTRANET_FULL_WIDTH_FIELD_SX} />
                            )}
                        />

                        <Autocomplete
                            options={roles}
                            value={roles.find(element => element.name === rol) || null}
                            onChange={(_event, newValue) => setRol(newValue ? newValue.name : '')}
                            getOptionLabel={option => option.name}
                            isOptionEqualToValue={(option, value) => String(option.id) === String(value.id)}
                            renderInput={params => (
                                <TextField {...params} label="Rol" required fullWidth sx={INTRANET_FULL_WIDTH_FIELD_SX} />
                            )}
                        />
                        

                        {/* <TextField
                            type="number"
                            label="Orden en About Us"
                            value={employeeOrder}
                            onChange={e => setEmployeeOrder(e.target.value === '' ? '' : Number(e.target.value))}
                            inputProps={{ min: 1 }}
                            helperText="Solo se valida contra usuarios con ‘Mostrar en About Us’ activo."
                            sx={INTRANET_FULL_WIDTH_FIELD_SX}
                            fullWidth
                        />

                        <Box sx={{ ...INTRANET_WIDE_FIELD_SX, display: 'flex', gap: 3, flexWrap: 'wrap' }}>
                            <FormControlLabel
                                control={<Checkbox checked={active} onChange={e => setActive(e.target.checked)} />}
                                label="Activo (Pide tu cita)"
                            />
                            <FormControlLabel
                                control={<Checkbox checked={showInAbout} onChange={e => setShowInAbout(e.target.checked)} />}
                                label="Mostrar en About Us"
                            />
                        </Box> */}


                        <TextField
                            label="Bio"
                            value={bio}
                            onChange={e => setBio(e.target.value)}
                            multiline
                            rows={5}
                            sx={INTRANET_WIDE_FIELD_SX}
                        />


                        <Box sx={{ ...INTRANET_WIDE_FIELD_SX, display: 'grid', gap: 1, justifyItems: 'center', pt: 2 }}>
                           
                          
                            {imagePreviewUrl && (
                                <Box sx={{ position: 'relative', width: 220, height: 220 }}>
                                    <Avatar
                                        src={imagePreviewUrl}
                                        alt="Previsualización"
                                        sx={{ width: 220, height: 220 }}
                                        variant="rounded"
                                    />
                                    <IconButton
                                        onClick={handleRemoveImage}
                                        size="small"
                                        sx={{
                                            position: 'absolute',
                                            top: -10,
                                            right: -10,
                                            bgcolor: 'background.paper',
                                            border: theme => `1px solid ${theme.palette.divider}`,
                                            '&:hover': { bgcolor: 'grey.100' }
                                        }}
                                        aria-label="Eliminar foto"
                                    >
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                </Box>
                            )}
                              {fileName && (
                                <Typography variant="body2" color="text.secondary">
                                    {fileName}
                                </Typography>
                            )}
                             <Button variant="contained" component="label" sx={{height:'fit-content', alignSelf: 'end'}} >
                                Subir foto del usuario
                                <input type="file" hidden accept="image/*" onChange={handleImageChange} />
                            </Button>
                        </Box>


                      
                        <Box sx={{ ...INTRANET_WIDE_FIELD_SX, display: 'flex', justifyContent: 'center' }}>
                            <Button type="submit" variant="contained">Guardar</Button>
                        </Box>
                    </Box>
                </CardContent>
            </Card>
        </Container>
        </>

    );

    // Guarda el usuario tanto si es un nuevo como si es un update
    async function handleGuardar(e) {
        e.preventDefault();
        if (password && !validatePassword(password)) {
            showNotification('La contraseña debe tener al menos 8 caracteres, una mayúscula, una minúscula y un número', 'error');
            return;
        }

        try {
            const usersList = await endPoints.getAllUsers();
            const allUsers = Array.isArray(usersList) ? usersList : usersList?.data || [];
            const aboutUsersCount = allUsers.filter(u => u.id !== Number(id) && u.show_in_about !== false).length + (showInAbout ? 1 : 0);

            if (employeeOrder !== '' && employeeOrder !== null && employeeOrder !== undefined) {
                const orderNumber = Number(employeeOrder);
                if (!Number.isInteger(orderNumber) || orderNumber < 1 || orderNumber > Math.max(aboutUsersCount, 1)) {
                    showNotification(`El orden debe estar entre 1 y ${aboutUsersCount} (usuarios mostrados en About Us).`, 'error');
                    return;
                }

                const duplicated = allUsers.find(u => u.id !== Number(id) && u.show_in_about !== false && Number(u.employee_order) === orderNumber);
                if (duplicated && showInAbout) {
                    showNotification('Ese número de orden ya está en uso por otro usuario visible en About Us.', 'warning');
                    return;
                }
            }

            await endPoints.updateUser(
                id,
                name,
                lastName,
                email,
                rol,
                password,
                bio,
                image,
                category,
                service,
                color,
                false,
                employeeOrder,
                removeCurrentImage,
                active,
                showInAbout
            );
            showNotification('Usuario actualizado', 'success');
            navigate('/admin/usuarios');
        } catch (_err) {
            showNotification('Error actualizando usuario', 'error');
        }
    }
}
